import { initMonitor } from '@issuu/tracking-micro';
import logger from './logger';
const TrackingCreate = ({ pingbackHost, trackingKey, countryCode = 'unknown', }) => {
    if (!trackingKey || trackingKey.includes('.')) {
        throw new Error('trackingKey can not be empty or include dot');
    }
    const monitor = initMonitor({
        pingbackHost,
    });
    const track = (eventShortName, timeElapsed) => {
        const event = {
            type: `ads-widget.${trackingKey}.${eventShortName}`,
            countryCode,
            timeElapsed,
            screenWidth: window.innerWidth,
            screenHeight: window.innerHeight,
            screenResolution: `${window.innerHeight}*${window.innerWidth}`,
        };
        logger.log('ads', 'pingback', event);
        monitor(event);
    };
    const adRequested = (timeElapsed) => {
        track('requested', timeElapsed);
    };
    const adFailed = (timeElapsed) => {
        track('failed', timeElapsed);
    };
    const adFilled = (timeElapsed) => {
        track('filled', timeElapsed);
    };
    const adViewable = (timeElapsed) => {
        track('viewable', timeElapsed);
    };
    const adTimeout = (timeElapsed) => {
        track('timeout', timeElapsed);
    };
    const adUnfilled = (timeElapsed) => {
        track('unfilled', timeElapsed);
    };
    return {
        adRequested,
        adFailed,
        adFilled,
        adViewable,
        adTimeout,
        adUnfilled,
    };
};
export default TrackingCreate;
//# sourceMappingURL=tracking.js.map